module.exports = __webpack_public_path__ + "static/Q1_2024_Investor_Presentation_v2-4c135062e32f71946f3ae5e9c5676152.pdf";